export const gray_tone="#444a59"
export const gold_tone="#e44044"